module.exports = __webpack_public_path__ + "static/media/hackathon1.d4e222d3.png";